export default {
  tenantName: import.meta.env.VITE_TENANT_NAME ?? '',
  gaTrackingId: import.meta.env.VITE_GTM_KEY ?? '',
  gaClientName: import.meta.env.VITE_GTM_CLIENT_NAME ?? '',
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  publicUrl: import.meta.env.VITE_PUBLIC_URL ?? '',
  olrUrl: import.meta.env.VITE_OLR_URL ?? ''
};
